export const isWithdraw = [
    {label: 'مشاهده شده', value: true},
    {label: 'مشاهده نشده', value: false},
]

